import { Injectable } from '@angular/core';
import { Toast } from './toast.types';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

/**
 * @servicedesc Service to generate or remove Toast type notifications.
 *
 * @name ToastService
 * @service
*/
export class ToastService {
  toasts: Toast[] = [];

  subject = new BehaviorSubject<Toast[]>(null);
  toasts$ = this.subject.asObservable();
  
  /**
  * This method has as purpose to add new messages to the Toast component.
  *
  * @method
  * @name ToastService#add
  * @param {object} toast Object has the type and message 
  * as required information and optionally a title.
  * 
  * @description The types accepted in the type key are:
  *   info' | 'error' | 'warning' | 'success'
  * 
  * @example <caption> 
  *  this._toastService.add({
  *   id: 123
  *   type: 'info' | 'error' | 'warning' | 'success',
  *   title: 'Well done!',
  *   message: 'This is a success alert'
  *  });
  * </caption>
  * 
  * @example <caption> 
  *  let id = this._toastService.add({
  *   type: 'info' | 'error' | 'warning' | 'success',
  *   title: 'Well done!',
  *   message: 'This is a success alert'
  *  });
  * </caption>
  * 
  * @returns {id} returns the id of the generated toast
  * if none was sent when calling the service.
  * @example Generated id example: id-df5b93135952d 
  *
  */
  add( toast: Toast ) {
    let id = toast?.id ?? 'id-' + Math.random().toString(16).slice(2);    
    toast.id = id;
    let ifExist = this.toasts.filter((toast, i) => toast.id === id);    

    if (ifExist === undefined || ifExist.length == 0) {
      this.toasts = [toast, ...this.toasts];
      this.subject.next(this.toasts);
      return id;
    }
  }
  /**
  * This method is intended to delete messages by id to the Toast component.
  *
  * @method
  * @name ToastService#remove
  * @param {id} number toast notification identifier.
  * 
  * @example <caption> 
  *      this._toastService.remove(id);
  * </caption>
  *
  */
  remove( id: string ) {
    this.toasts = this.toasts.filter((toast, i) => toast.id !== id);
    this.subject.next(this.toasts);
  }

  /**
  * This method is intended to delete all messages to the Toast component.
  *
  * @method
  * @name ToastService#removeAll
  * 
  * 
  * @example <caption> 
  *      this._toastService.removeAll();
  * </caption>
  *
  */
  removeAll() {    
    this.toasts =  [];
    this.subject.next(this.toasts);
  }
}
  